import Vue from 'vue';
import { formatSessionInfoHumanTimeAgo, formattedCreatedAt } from '@/utils/sessionFormatters';
export default Vue.extend({
    name: 'SearchResultRow',
    props: {
        result: {
            type: Object,
            required: true
        },
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        timeAgo() {
            if (!this.result.session)
                return '';
            return formatSessionInfoHumanTimeAgo(this.result.session);
        },
        absoluteDate() {
            if (!this.result.session)
                return '';
            return formattedCreatedAt(this.result.session);
        }
    },
    methods: {
        handleSessionClick() {
            // For session type, navigate to session (existing behavior)
            // For category/project type, navigate to category/project
            this.$emit('result-clicked', this.result);
        },
        handleProjectClick() {
            // Always navigate to project (expand and scroll)
            this.$emit('project-clicked', {
                project: this.result.project,
                sessionId: this.result.id // Pass session ID for highlighting
            });
        },
        handleCategoryClick() {
            // Navigate to category (expand and scroll)
            if (this.result.category) {
                this.$emit('category-clicked', {
                    project: this.result.project,
                    category: this.result.category,
                    sessionId: this.result.id // Pass session ID for highlighting
                });
            }
        }
    }
});
